<template>
  <DBox :id="'cmp-contacts-group_info'" :addButton="false" :addLink="false" :addLinkLabel="''">
    <TextField2 :id="'group_name'" :label="$t('group')" :placeholder="$t('group')" :value="group.group_name"
      @change="onGroupTextFieldValueChange">
    </TextField2>
    <!-- <TextField2
      :id="`${pt_prefix}_due_days`"
      :value="accountingInfo.contact[`${pt_prefix}_due_days`]"
      :label="$t('due_days')"
      :placeholder="$t('due_days')"
      @change="onTextFieldValueChange"
    /> -->
    <!-- <input
                    type="checkbox"
                    @click="e => onArtistCheckboxChange(e)"
                    :name="group.group_id"
                    :id="group.group_id"
                    :checked="group.private == '1'"
                  > -->
    <Checkbox2 :id="`${group.group_id}`" :label="$t('private')" :value="group.private" :placeholder="$t('private')"
      @input="onArtistCheckboxChange" />
    <!-- <Checkbox2
      :id="`${pt_prefix}_end_of_month_flag`"
      :label="$t('end_of_month')"
      :value="
        accountingInfo.contact[`${pt_prefix}_end_of_month_flag`]
      "
      :placeholder="$t('end_of_month')"
      @input="onCheckboxChange"
    /> -->
    <TextField2 :id="'comment'" :label="$t('description')" :placeholder="$t('description')" :value="group.comment"
      @change="onGroupTextFieldValueChange" textarea bb="none">
    </TextField2>
    <!-- <TextField2
      :id="`${pt_prefix}_discount_days`"
      :value="
        accountingInfo.contact[`${pt_prefix}_discount_days`]
      "
      :label="$t('discount_days')"
      :placeholder="$t('discount_days')"
      @change="onTextFieldValueChange"
    /> -->


  </DBox>
</template>

<script>
import TextField from "@plugins/text-field/text-field";
import Dropdown from "@plugins/dropdown/dropdown";
import DBox from "@dtplugins/dbox/dbox";
import { EventHooks } from "../../../../plugins/text-field";
import { createCountriesTV } from "../../../../models/country.model";
import { createCurrencyTV } from "../../../../models/currency.model";
import EmailsModal from "./emails-modal";
import FileDownload from "js-file-download";

export default {
  components: {
    TextField,
    EmailsModal,
    DBox
  },
  props: {
    group: {
      type: Object
    },
    selectedContactGroup: {
      type: Object
    }
  },
  data: function () {
    return {
      // textFieldConfig: {
      //   height: 42,
      //   showEditIconOnHover: false,
      //   box: true,
      //   showValidationIcons: false,

      //   validationEvent: EventHooks.OnBlur,
      //   valueChangedEvent: EventHooks.OnBlur,
      // },
      groupEmailsModal: false,
      groupEmails: []
    };
  },
  methods: {
    onGroupTextFieldValueChange: function (payload) {
      // HttpClient.modify("group_id", this.group.group_id, name, value, "groups");
      this.$emit('changed', payload);
    },
    onArtistCheckboxChange: function ({ name, value }) {
      const cvalue = value === true ? "1" : "0";

      this.onGroupTextFieldValueChange({ name: "private", value: cvalue });
    },
    // : function(e) {
    //   let value = e.target.checked ? "1" : "0";
    //   
    // },
    onCSVButtonClicked() {
      ContactGroupsService.getContactGroupCSV(this.group.group_id).then(res => {
        FileDownload(res.data, this.group.group_name + "_contacts.csv");
      });
    },
    onGroupEmailsModalOpen() {
      this.groupEmailsModal = true;
      ContactGroupsService.getContactGroupEmails(this.group.group_id).then(
        res => {
          let formatedArr = [];
          res.data.contact_emails.forEach(el => {
            if (el.email1) {
              formatedArr.push(el.email1);
            }
            if (el.email2) {
              formatedArr.push(el.email2);
            }
          });
          this.groupEmails = formatedArr.join("\n");
        }
      );
    },
    onGroupEmailsModalCancelled() {
      this.groupEmailsModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.form-group .dt-dropdown {
  margin: 5px 5px !important;
}

.eom-flag {
  display: flex;

  .dt-checkbox,
  .eom-label {
    margin-left: 7px;
    margin-top: 15px;
  }
}
</style>
